
























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { UserBadge } from '@/models/profile';

@Component
export default class ProfileBadge extends Vue {
    @Prop(Object) public userBadge: UserBadge;
    @Prop(Boolean) public large: boolean;

    private emitClick() {
        this.$emit('badgeClick', this.userBadge);
    }
}
